const Timeline = ({ attributes, }) => {
    const { userName, config } = attributes;
    const { theme, width, height, scrolling, isHeader, isFooter, language } = config;

    // eslint-disable-next-line react/no-unknown-property
    return <iframe Scrolling={scrolling} frameBorder="0" allowtransparency="true" allowFullScreen="true" className="twitter_iframe" style={{ position: 'static', visibility: 'visible', width: `${width}`, height: `${height}`, flexGrow: 1, overflow: "auto" }} title="Twitter Timeline" src={`https://syndication.twitter.com/srv/timeline-profile/screen-name/${userName}?dnt=false&frame=false&hideBorder=true&showHeader=${isHeader}&hideFooter=${!isFooter}&lang=${language}&showReplies=false&theme=${theme}&transparent=false&order_by=asc`}></iframe>;
}
export default Timeline;

// import { useEffect, useRef } from 'react';

// const Timeline = ({ attributes }) => {
//     const { userName, config } = attributes;
//     const { theme, width, height, language } = config;
//     const ref = useRef(null);

//     useEffect(() => {
//         const loadTwitterWidget = () => {
//             if (window.twttr && window.twttr.widgets) {
//                 window.twttr.widgets.load(ref.current);
//             }
//         };

//         if (!window.twttr) {
//             const script = document.createElement('script');
//             script.src = "https://platform.twitter.com/widgets.js";
//             script.async = true;
//             script.onload = loadTwitterWidget;
//             document.body.appendChild(script);
//         } else {
//             loadTwitterWidget();
//         }

//         return () => {
//             // Cleanup if needed
//         };
//     }, [userName, theme, language, width, height]);

//     return (
//         <div ref={ref}>
//             <a
//                 className="twitter-timeline"
//                 data-theme={theme}
//                 data-lang={language}
//                 data-width={width}
//                 data-height={height}
//                 href={`https://twitter.com/${userName}`}
//             >
//                 Tweets by {userName}
//             </a>
//         </div>
//     );
// };

// export default Timeline;
